"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterE = exports.witherDefault = exports.wiltDefault = void 0;
var _ = __importStar(require("./internal"));
function wiltDefault(T, C) {
  return function (F) {
    var traverseF = T.traverse(F);
    return function (wa, f) {
      return F.map(traverseF(wa, f), C.separate);
    };
  };
}
exports.wiltDefault = wiltDefault;
function witherDefault(T, C) {
  return function (F) {
    var traverseF = T.traverse(F);
    return function (wa, f) {
      return F.map(traverseF(wa, f), C.compact);
    };
  };
}
exports.witherDefault = witherDefault;
function filterE(W) {
  return function (F) {
    var witherF = W.wither(F);
    return function (predicate) {
      return function (ga) {
        return witherF(ga, function (a) {
          return F.map(predicate(a), function (b) {
            return b ? _.some(a) : _.none;
          });
        });
      };
    };
  };
}
exports.filterE = filterE;